export default [
  {
    path: "/administrador/menu",
    name: "Administrador",
    meta: { layout: "default" },
    component: () => import("@/views/administrador/menu.vue"),
  },

  {
    path: "/visualizar-contas",
    name: "Contas Bancárias",
    meta: { layout: "default" },
    component: () => import("@/views/administrador/visualizar-contas.vue"),
  },

  {
    path: "/Novo-banco",
    name: "Novo Banco",
    meta: { layout: "default" },
    component: () => import("@/views/administrador/Novo-banco.vue"),
  },

  {
    path: "/pesquisar-formas-pagamentos",
    meta: { layout: "default" },
    name: "Formas de pagamentos",
    component: () => import("@/views/administrador/tpaListagem.vue"),
  },

  {
    path: "/novo-emolumento",
    name: "Novo Emolumento",
    meta: { layout: "default" },
    component: () => import("@/views/administrador/Novo-Produto.vue"),
  },

  {
    path: "/emolumentos",
    name: "Emolumentos",
    meta: { layout: "default" },
    component: () => import("@/views/administrador/Emolumentos.vue"),
  },

  {
    path: "/registrosAssociados",
    name: "Registros Associados",
    meta: { layout: "default" },
    component: () => import("@/views/administrador/RegistrosAssociados.vue"),
  },

  {
    path: "/pesquisar-prazo-multas",
    name: "Prazo de Multas",
    meta: { layout: "default" },
    component: () => import("@/views/administrador/multas-prazo-listagem.vue"),
  },

  {
    path: "/pesquisar-valor-multas",
    name: "Valores Das Multas",
    meta: { layout: "default" },
    component: () => import("@/views/administrador/definir-valor-Listagem.vue"),
  },

  {
    path: "/definir-valor",
    meta: { layout: "default" },
    name: "Definir Valor Multa",
    component: () => import("@/views/administrador/definir-valor.vue"),
  },
];
